(function () {
  function init() {
    document.querySelectorAll('[data-section-id]').forEach(section => {
      const video = section.querySelector('[data-howto-video]');
      if (!video) return;

      const muteBtn = section.querySelector('[data-howto-mute]');
      const playBtn = section.querySelector('[data-howto-play]');

      // Mute toggle
      if (muteBtn) {
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.setAttribute('aria-pressed', String(video.muted));
        });
      }

      // Play/pause toggle
      if (playBtn) {
        playBtn.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            playBtn.setAttribute('aria-pressed', 'true');
          } else {
            video.pause();
            playBtn.setAttribute('aria-pressed', 'false');
          }
        });

        // Keep button state synced if video pauses for other reasons
        video.addEventListener('play', () => playBtn.setAttribute('aria-pressed', 'true'));
        video.addEventListener('pause', () => playBtn.setAttribute('aria-pressed', 'false'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();